<div class="row">
  <div class="col-12">
    <app-proxy-interface-data-settings [interfaceDatas]="interfaceDataSuppliers[0]"
      [supplierInterfaceData]="supplierInterfaceData"
      (interfaceDataChanged)="interfaceDataChanged.emit($event)"></app-proxy-interface-data-settings>
  </div>
</div>